export default "__VITE_ASSET__e74747f6__"